export default __webpack_public_path__ + "static/media/AMS_D.03ec3852.svg";